// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7be81e2c","601":"24377211","787":"6122bfeb"}[chunkId] + ".chunk.js";
};